export enum PasswordType {
  RESET = 'reset',
  ACTIVATE = 'activate',
}
